import { HStack, Icon, Text, WrapItem } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { ReactNode } from 'react';

export type ProfileFeatureItem = {
  icon: IconType;
  label: string;
  appendedElement?: ReactNode;
  show: boolean;
};

interface ProfileFeatureItemProps {
  item: ProfileFeatureItem;
  variant?: 'full' | 'bullet-separated' | 'comma-separated';
  isLastInList?: boolean;
}

export const ProfileFeatureItem = ({
  item,
  variant = 'full',
  isLastInList = false,
}: ProfileFeatureItemProps) => {
  if (!item.show) return null;

  return (
    <WrapItem>
      <HStack spacing="2">
        {/* Icon */}
        {variant === 'full' && (
          <Icon as={item.icon} boxSize="20px" color="#171923" />
        )}
        {/* Label */}
        <Text
          size={variant === 'comma-separated' ? 'xs' : 'md'}
          color="black"
          fontWeight="medium"
        >
          {item.label}
          {variant === 'comma-separated' && !isLastInList && ','}
        </Text>

        {/* Extra */}
        {variant === 'full' && item.appendedElement && item.appendedElement}

        {/* Bullet for bullet variant */}
        {variant === 'bullet-separated' && !isLastInList && (
          <Text color="blackAlpha.500" size="xs" mr="1">
            •
          </Text>
        )}
      </HStack>
    </WrapItem>
  );
};
